function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M763.611429 109.714286A150.857143 150.857143 0 0 1 914.285714 260.388571v503.222858A150.857143 150.857143 0 0 1 763.611429 914.285714H260.388571A150.857143 150.857143 0 0 1 109.714286 763.611429V260.388571A150.857143 150.857143 0 0 1 260.388571 109.714286h503.222858z m0 84.699428H260.388571c-36.388571 0-65.938286 29.622857-65.938285 65.974857v503.222858c0 36.388571 29.549714 66.011429 65.974857 66.011428h503.149714c36.425143 0 65.974857-29.622857 65.974857-65.974857V260.315429c0-36.352-29.549714-65.974857-65.974857-65.974858v0.073143z m-82.212572 127.012572a42.349714 42.349714 0 0 1 0 84.699428h-127.049143v254.061715a42.349714 42.349714 0 0 1-84.699428 0v-254.061715H342.637714a42.349714 42.349714 0 0 1 0-84.699428h338.761143z",
  "p-id": 8323
});

var SvgVideoEditorSubtitle = function SvgVideoEditorSubtitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1595577519649,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 8322,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoEditorSubtitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video_editor_subtitle.068cdeb7.svg";
export { ForwardRef as ReactComponent };